import * as proto from 'src/proto/compiled-protos';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../services/session.service';
import { PageComponent } from '../../components/page/page.component';
import { AuthenticationStatus } from '../../util/util';
import { LocationHeaderComponent } from '../../components/location-header/location-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { TopLocationsComponent } from '../../components/top-locations/top-locations.component';
import { ProtoUtil } from '../../util/proto-util';
import { TimeUtil } from 'src/app/general/util/time-util';
import { Util } from 'src/app/general/util/util';
import { DeviceService } from 'src/app/general/services/device.service';
import { TableLayoutComponent } from 'src/app/general/components/table-layout/table-layout.component';

@Component({
  selector: 'app-top-locations-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    LocationHeaderComponent,
    TranslateModule,
    TopLocationsComponent,
    TableLayoutComponent
  ],
  templateUrl: './top-locations-page.component.html',
  styleUrls: ['./top-locations-page.component.css']
})
export class TopLocationsPageComponent implements OnInit {

  year: number;
  month: proto.waiternow.common.Month = proto.waiternow.common.Month.APRIL;
  day: number;

  constructor(
      private sessionService: SessionService,
      public deviceService: DeviceService) {

    const dateProto : proto.waiternow.common.DateProto | null | undefined = ProtoUtil.dateToDateProto(this.yesterday());
    this.year = Util.safeNumber(dateProto?.year);
    // Note that month cannot be undefined
    this.month = dateProto && dateProto.month ? dateProto?.month : proto.waiternow.common.Month.JANUARY;
    this.day = Util.safeNumber(dateProto?.day);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }
  }

  private yesterday(): Date {
    const nowMillis = TimeUtil.dateToMillis(TimeUtil.now());
    const yesterdayMillis = nowMillis - (1 * 24 * 60 * 60 * 1000);
    return TimeUtil.createDateFromMillis(yesterdayMillis);

  }
}
